<ng-container *ngIf="!showUpdatePhoneNumber">
  <div class="wrapper" *ngIf="user$ | async as user">
    <div *ngIf="!confirmedAt">
      <div class="font-semibold">
        Phone number status → 🟡 Waiting for phone number confirmation...
      </div>
      <p>
        <!-- Click the link we sent to your phone (***) ***-{{
          user.phoneNumber.slice(-4)
        }}. Not your number? -->
        Click the link we sent to your phone
        {{ user.phoneNumber.replace('+1', '').trim() }}. Not your number?
        <span
          class="text-primary-500 underline cursor-pointer"
          (click)="showUpdatePhoneNumber = true"
          >Update it</span
        >.
      </p>
      <p>
        The link in your phone will open in a new tab. Close the tab and you’re
        in!
        <ng-container *ngIf="sending">
          <span class="underline">Sending</span> new confirmation SMS...
        </ng-container>
        <ng-container *ngIf="!sending">
          <a
            href="javascript:void(0)"
            class="text-primary-500"
            (click)="requestNewLink()"
            >Click here</a
          >
          to request a new verification SMS.
        </ng-container>
      </p>
    </div>

    <div *ngIf="!!confirmedAt">
      <div class="font-semibold">
        Phone number status → ✅ Phone number confirmed!
      </div>
      <p>
        You have successfully confirmed your phone number. Waiting on phone
        number confirmation.
      </p>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showUpdatePhoneNumber">
  <ng-container *ngIf="user$ | async as user">
    <app-verify-identity-update-phone
      [currentPhoneNumber]="user.phoneNumber"
      (handleClose)="showUpdatePhoneNumber = false"
    ></app-verify-identity-update-phone>

    <div
      (click)="showUpdatePhoneNumber = false"
      class="mt-4 underline cursor-pointer"
    >
      Cancel phone number update.
    </div>
  </ng-container>
</ng-container>
